module.exports = __webpack_public_path__ + "img/sc.d9faf330.png";